module.exports = __webpack_public_path__ + "static/media/default-our-team.bc3658df.png";